import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Button, Spinner, Alert } from "react-bootstrap";
import * as familiaApi from "../../api/familia";

/** Página que abre el Jefe desde el enlace del correo (o desde "Mi Familia") para aprobar o
 * rechazar la solicitud de alguien que quiere unirse a su familia. */
export default function ResolverSolicitud() {
  const { token } = useParams();
  const [detalle, setDetalle] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const [resuelto, setResuelto] = useState(null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    familiaApi.obtenerSolicitud(token)
      .then(setDetalle)
      .catch((err) => setError(err?.response?.data?.mensaje || "No se pudo cargar la solicitud."))
      .finally(() => setCargando(false));
  }, [token]);

  const resolver = async (aprobar) => {
    setGuardando(true);
    setError("");
    try {
      await familiaApi.resolverSolicitud(token, aprobar);
      setResuelto(aprobar ? "aprobada" : "rechazada");
    } catch (err) {
      setError(err?.response?.data?.mensaje || "No se pudo resolver la solicitud.");
    } finally {
      setGuardando(false);
    }
  };

  if (cargando) return <Spinner animation="border" />;

  return (
    <div>
      <h4 className="mb-3">Solicitud para unirse a tu familia</h4>
      <div className="fs-card" style={{ maxWidth: 520 }}>
        {error && <Alert variant="danger" className="py-2">{error}</Alert>}
        {resuelto ? (
          <Alert variant={resuelto === "aprobada" ? "success" : "secondary"} className="mb-0">
            Solicitud {resuelto === "aprobada" ? "aprobada" : "rechazada"}.
          </Alert>
        ) : detalle && (
          <>
            <p>
              <strong>{detalle.nombres}</strong> <span className="text-muted">({detalle.email})</span> pidió unirse a{" "}
              <strong>{detalle.nombreFamilia}</strong>.
            </p>
            {detalle.estado !== "Pendiente" ? (
              <Alert variant="secondary" className="mb-0">Esta solicitud ya fue resuelta ({detalle.estado}).</Alert>
            ) : (
              <div className="d-flex gap-2">
                <Button variant="outline-danger" disabled={guardando} onClick={() => resolver(false)}>Rechazar</Button>
                <Button variant="primary" disabled={guardando} onClick={() => resolver(true)}>
                  {guardando ? <Spinner size="sm" animation="border" /> : "Aprobar"}
                </Button>
              </div>
            )}
          </>
        )}
        <div className="mt-3">
          <Link to="/mi-familia" className="small">Ir a Mi Familia</Link>
        </div>
      </div>
    </div>
  );
}
